export default "__VITE_ASSET__DDmnIfR___"